import { Product } from '../types';

type ProductSelectionValue = number | string | null | undefined;

const normalizeSelectedProductIds = (selectedIds: readonly ProductSelectionValue[]) => {
  const normalized = new Set<number>();

  selectedIds.forEach((value) => {
    if (value === null || value === undefined || value === '') return;

    const parsed = typeof value === 'number' ? value : parseInt(String(value), 10);
    if (Number.isFinite(parsed) && parsed > 0) {
      normalized.add(parsed);
    }
  });

  return normalized;
};

export const getSelectableProducts = (
  products: readonly Product[],
  selectedIds: readonly ProductSelectionValue[] = []
) => {
  const selectedProductIds = normalizeSelectedProductIds(selectedIds);
  return products.filter((product) => product.isActive || selectedProductIds.has(product.id));
};

export const getSelectableProductSearchItems = (
  products: readonly Product[],
  selectedIds: readonly ProductSelectionValue[] = []
) =>
  getSelectableProducts(products, selectedIds).map((product) => ({
    id: String(product.id),
    name: product.name,
  }));
